<div style="display: flex; align-items: center;">
    <ng-container *ngIf="displayActions">
        <div style="margin-right: 10px; font-size: 12px;">
            <button  class="btn btn-primary" [disabled]="!assetsDebugRight()"
                (click)="openCommandPrompt()"><fa-icon [icon]="faTerminal"></fa-icon></button>
        </div>
        <div style="margin-right: 6px;">
            <button  class="btn btn-primary" [disabled]="!assetssetWifiRight()" (click)="setWifi()"
            placement="bottom" [ngbTooltip]="'This will configure WiFi settings on selected devices'">Set WiFi</button>
        </div>
        <div style="margin-right: 6px;">
            <button  class="btn btn-primary" [disabled]="!assetsrebootRight()" (click)="onReboot()"
            placement="bottom" [ngbTooltip]="'This will reboot selected devices'">Reboot/Reset</button>
        </div>
        <div style="margin-right: 6px;">
            <button  class="btn btn-primary" [disabled]="!assetsresetAPNRight()" (click)="setApn()"
            placement="bottom" [ngbTooltip]="'This will configure APN settings on selected modems'">Set APN</button>
        </div>
        <div style="margin-right: 6px;">
            <button  class="btn btn-primary" [disabled]="!assetsdeleteRight()" (click)="delete()">Delete</button>
        </div>
        <!-- <div style="margin-right: 6px;">
            <button  class="btn btn-primary" disabled (click)="upGrade()">Upgrade</button>
        </div> -->
        <div style="margin-right: 6px;">
            <button  class="btn btn-primary" [disabled]="!assetsaddDeviceRight()" (click)="addDevice()">Add Device
            </button>
        </div>
       
          
        <!-- <button mat-icon-button [matMenuTriggerFor]="deviceMenu" matTooltip="More Device Actions" style="background-color: #e3f2fd; border-radius: 50%;">
            <mat-icon color="primary">tune</mat-icon>
          </button> -->
    </ng-container>
   
      
    <!-- <div *ngIf="pageName=='Telemetry'" class="mt-1 mr-2">
        <button type="button" class="btn btn-primary" id="device-status-btn-" name="device-status-btn"  
             (click)="onClickDevicetatus()">Device Health Status
        </button>
    </div> -->
    <ng-container *ngIf="walktestActions">
   <!-- <div style="height: 100%;border: 1px solid grey; border-radius: 5px; display: flex;
   flex-direction: row; margin-right: 10px;padding:0px 2px" >
      <div style="margin: auto;padding:2px;font-size: 12px;" >
       View Type
      </div>
      <div style="border-left: 1px solid grey;padding:0px 10px;font-size: 12px;">
        <div class="form-check" style="min-height: 0.5em;">
            <input class="form-check-input" type="radio" name="flexRadioDefault" id="viewTypeScan" (click)="handleViewType($event, 'scan')" >
            <label class="form-check-label" for="viewTypeScan">
              Scan
            </label>
          </div>
          <div class="form-check" style="min-height: 0.5em;">
            <input class="form-check-input" type="radio" name="flexRadioDefault" id="viewTypeHandovers" (click)="handleViewType($event,'handover')">
            <label class="form-check-label" for="viewTypeHandovers">
              Handovers
            </label>
          </div>
      </div>
    </div> -->  
       <div style="margin-right: 10px; font-size: 12px;">
        
        <button title="test configurations"  class="btn btn-primary" [disabled]="!liveWalkTest()"
            (click)="openTestConfigurations()">
            <img style="pointer-events: none;max-width: 50%;" src="/assets/svgs/configsettings.svg"
             alt="Netflix" />
        </button>
       </div>
       <!-- <div style="margin-right: 10px; font-size: 12px;">
        <button  class="btn btn-primary"
            (click)="goToTelemetry('WalkTest')">Go to Telemetry</button>
    </div> -->
        <div style="margin-right: 10px; font-size: 12px;">
            <button  class="btn btn-primary" [disabled]="!liveWalkTest() || !deviceStatus||!selectedDevice?.[0]"
                (click)="openCommandPrompt()">Ping</button>
        </div>
        <div style="margin-right: 6px;">
            <button  class="btn btn-primary" [disabled]="!liveWalkTest()" (click)="openOnGoing()">Ongoing
                Tests</button>
        </div>

        <div style="margin-right: 6px;">
            <button  class="btn btn-primary" [disabled]="!liveWalkTest()" (click)="stopTest()">Stop
                Test</button>
        </div>

        <div style="margin-right: 6px;">
            <button  class="btn btn-primary" [disabled]="disableWalktestActions ||!selectedMap?.[0]||!selectedDevice?.[0]|| !liveWalkTest()"
                (click)="startTest()">Start Test</button>
        </div>
        <div class="multi-select-angular position-relative" style="margin-right: 6px; width: 150px; " *ngIf="!isDetailedReport">
             
            <!-- // liveWalkTest map dropdown -->
            <!-- <label name="label-imei" id="label-imei" class="m-0">IMEI Number 1</label> -->
            <angular2-multiselect name="multiselect-devices" id="multiselect-devices"
                class="hide_checkbox-select data_modelClas add_map_direction" [settings]="multipleSettings2" [lazyLoading]="true"
                [data]="walktestMaplist" [(ngModel)]="selectedMap" (ngModelChange)="changeMap($event, true)">
                <c-item>
                    <ng-template let-item="item">
                      <div *ngIf="item.isHeader; else normalItem" (click)="onAddNewMap()" class="custom-add-map">
                        <strong style="color: #007bff; cursor: pointer;">+ Add New Map</strong>
                      </div>
                      <ng-template #normalItem>
                        <label>{{ item.name }}</label>
                      </ng-template>
                    </ng-template>
                  </c-item>
            </angular2-multiselect>
        <div class="position-absolute translate-middle " style="right: 1%; top:40%" >
            <div *ngIf="loadMaps" class="loader"></div>
        </div>
    </div>
    </ng-container>


 <!-- // walktest scheduler device dropdown -->
    <ng-container *ngIf="pageName=='Test Scheduler'">
        <div style="margin-right: 6px;">
            <button  class="btn btn-primary" [disabled]="disableWalktestActions || !walktestSchduler()"
                (click)="startTest()">Schedule Test</button>
        </div>

        <div class="multi-select-angular" style="margin-right: 6px;  width: 150px;display:none" *ngIf="!isDetailedReport">
            <!-- <label name="label-imei" id="label-imei" class="m-0">IMEI Number 2</label> -->
            <angular2-multiselect name="multiselect-devices" id="multiselect-devices"
                class="hide_checkbox-select data_modelClas" [settings]="multipleSettings2" [lazyLoading]="true"
                [data]="maplist" [(ngModel)]="selectedMap" (ngModelChange)="changeMap($event)">
                <c-item>
                    <ng-template let-item="item">
                        <label>{{item.name}}</label>
                    </ng-template>
                </c-item>
            </angular2-multiselect>
        </div>
    </ng-container>

    <ng-container *ngIf="pageName=='Detailed Report'||pageName=='Device Locator'">
        <div style="margin-right: 6px;" *ngIf="pageName!='Device Locator'" >
            <button  class="btn btn-primary" [disabled]="disableDetailedSubmit"
                (click)="handleDetailedReport()">Submit</button>
        </div>

        <div class="multi-select-angular" style="margin-right: 6px; width: 150px;" *ngIf="!isDetailedReport">
            <!-- <label name="label-imei" id="label-imei" class="m-0">IMEI Number 3</label> -->
             <!-- device locator map dropdown -->
            <angular2-multiselect name="multiselect-devices" id="multiselect-devices"
                class="hide_checkbox-select data_modelClas" [settings]="multipleSettings2" [lazyLoading]="true"
                [data]="maplist" [(ngModel)]="selectedMap" (ngModelChange)="changeMap($event)">
                <c-item>
                    <ng-template let-item="item">
                        <label>{{item.name}}</label>
                    </ng-template>
                </c-item>
            </angular2-multiselect>
        </div>
    </ng-container>


    <ng-container *ngIf="pageName =='MNO Mapping'">
        
            <div style="text-align: end;padding: 0px;margin-right: 10px;">
                <button  class="btn btn-primary"  [disabled]="!mnoMapping()"
                    (click)="openConfigureModal()">Configure MNO <i class="fa fa-gear"
                        ></i></button>
            </div>
            <div style="text-align: end;padding: 0px;margin-right: 0px;">
                <button  class="btn btn-primary" data-toggle="modal" [disabled]="!mnoMapping()"
                    (click)="OpenMNOAddPopup()" data-target="#exampleModalCenter">New MNO Map <i class="fa fa-plus"
                        aria-hidden="true"></i></button>
            </div>
      
    </ng-container>
    <ng-container *ngIf="pageName =='Floor Maps Manager'">
        <div style="text-align: end;padding: 0px;margin-right: 0px;">
            <button type="button" class="btn btn-primary" style="margin-right: 20px;" [disabled]="!floorMapsManager()"
                (click)="OpenPopup('html')">Add Map
                +</button>
        </div>
        <div style="text-align: end;padding: 0px;margin-right: 0px;">

            <button type="button" (click)="openImportPopup()" class="btn btn-primary" [disabled]="!floorMapsManager()"
                style="margin-right: 20px;">Import
                from csv</button>
        </div>
    </ng-container>
    <ng-container *ngIf="pageName =='Groups Manager'">
        <div style="text-align: end;padding: 0px;margin-right: 0px;">
            <button type="button" class="btn btn-primary" style="margin-right: 20px;" [disabled]="!groupsManager()"
                (click)="OpenPopupNewGroup()">New
                Group <i class="fa fa-plus" aria-hidden="true"></i></button>
        </div>


    </ng-container>
    <ng-container *ngIf="pageName =='Roles Manager'">
        <div style="text-align: end;padding: 0px;margin-right: 0px;">
            <button type="button" class="btn btn-primary" style="margin-right: 20px;" [disabled]="!rolesManager()"
                (click)="OpenPopupNewProfile()">New
                Profile <i class="fa fa-plus" aria-hidden="true"></i></button>
        </div>


    </ng-container>
    <ng-container *ngIf="pageName =='Users Manager'">
        <div style="text-align: end;padding: 0px;margin-right: 0px;">
            <button type="button" class="btn btn-primary" style="margin-right: 20px;" [disabled]="!usersManager()"
                (click)="OpenPopupNewUser()">New
                User <i class="fa fa-plus" aria-hidden="true"></i></button>
        </div>


    </ng-container>
    <!-- <div *ngIf="imeiDropdown" style="margin-right: 6px; font-size: 12px; position: relative; top: 10px;">
        <label name="label-imei" id="label-imei">IMEI Number</label>
    </div> -->
<div *ngIf="pageName =='GPS Report' || currentUrl=='/gps-report'"> 
    <button mat-raised-button class="btn-primary mr-2" name="generateReport" id="generateReport" (click)="generateReport()">Generate Report</button>
</div>
    <div *ngIf="eventTypeShow" style="margin-right: 6px;">
        <button  class="btn btn-primary" (click)="handleNotificationSubmit()">Submit</button>
    </div>
    <div *ngIf="eventTypeShow" class="multi-select-angular" style="margin-right: 6px;">
        <!-- <label name="label-imei" id="label-imei" class="m-0">IMEI Number</label> -->
        <!-- <label name="label-imei" id="label-imei" class="m-0">IMEI Number</label> -->
        <!-- {{devices}} -->
        <!-- <label name="label-imei" id="label-imei" class="m-0">IMEI Number 4</label> -->
        <angular2-multiselect name="multiselect-devices" id="multiselect-devices"
            class="hide_checkbox-select data_modelClas" [data]="eventTypes" [(ngModel)]="selectedEventType"
            (onSelect)="changeEventType($event)" [settings]="multipleSettings3">
            <c-item>
                <ng-template let-item="item">
                    <label>{{item.type_name }}</label>
                </ng-template>
            </c-item>
        </angular2-multiselect>

    </div>
    <!-- // global Notifications   not used--> 
    <div *ngIf="eventTypeShow" class="multi-select-angular" style="margin-right: 6px;">
        <!-- <label name="label-imei" id="label-imei" class="m-0">IMEI Number 5</label> -->
        <angular2-multiselect name="multiselect-devices" id="multiselect-devices"
            class="hide_checkbox-select data_modelClas" [data]="notificationDevices"
            [(ngModel)]="selectedNotificationDevice" [settings]="multipleSettings5">
            <c-item>
                <ng-template let-item="item">
                    <label>{{item.deviceid}} ({{item.name}})</label>
                </ng-template>
            </c-item>
        </angular2-multiselect>
    </div>
    <div *ngIf="redirectAction && !showBackButton" style="margin-right: 10px; font-size: 12px;">
        <button  class="btn btn-primary" 
            (click)="goToTAssets('Telemetry')">Go to Assets</button>
    </div>
    <div *ngIf="redirectAction && !showBackButton" style="margin-right: 10px; font-size: 12px;">
        <button  class="btn btn-primary" 
            (click)="goToWalktest('Telemetry')">Go to Active Test</button>
    </div>

    <!--walktest, scheduler,  telemetry, device Configuration, Device Locator, video stream,  edge intelligence, data model-->
    <div *ngIf="imeiDropdown&&!isDetailedReport" class="multi-select-angular" style="margin-right: 6px;min-width: 230px !important;">
        <!-- <h5>Not Detailed Report</h5> -->
        <!-- <label name="label-imei" id="label-imei" class="m-0">IMEI Number 6</label> -->
        <angular2-multiselect name="multiselect-devices" id="multiselect-devices"
            class="hide_checkbox-select data_modelClas" [data]="devices" [(ngModel)]="selectedDevice"
            (ngModelChange)="ChangeDevice()" [settings]="multipleSettings1">           
            <c-item>
                <ng-template let-item="item">
                    <label>{{item.deviceid}} ({{item.name}})
                        <span > <fa-icon [icon]="faInfoCircle" class="ml-1" for="customcheckbox" (click)="handleBandInfoCHeck($event,item)"></fa-icon></span> 
                    </label>
                </ng-template>
            </c-item>
        </angular2-multiselect>
    </div>

    <div class="position-relative">
        <!-- // walktest detailed Report -->
        <div *ngIf="imeiDropdown&&isDetailedReport" class="multi-select-angular" style="margin-right: 6px; min-width: 210px !important;" >
            <!-- <label name="label-imei" id="label-imei" class="m-0">IMEI Number 7</label> -->
            <angular2-multiselect name="multiselect-devices" id="multiselect-devices"
                class="hide_checkbox-select data_modelClas" [data]="devicesReprt" [(ngModel)]="selectedReportDevice"
                (ngModelChange)="ChangeDevice()" [settings]="multipleSettings1">
                <c-item>
                    <!-- <ng-template let-item="item">
                        <label>{{item.deviceid}} ({{item.name}})</label>
                    </ng-template> -->
                    <ng-template let-item="item">
    
                        <label>{{item.deviceid}} ({{item.name}}) 
                        <span *ngIf="item?.isWifi"  >
                            <span ><fa-icon [icon]="faWifi" class="ml-1" for="customcheckbox" (click)="handleWifiCheck($event)"></fa-icon></span>
                        </span></label>
                    </ng-template>
                </c-item>
            </angular2-multiselect>
        </div>
        <div class="position-absolute translate-middle " style="right: 1%; top:40%" >
            <div *ngIf="fetchingDevices" class="loader"></div>
        </div>
     </div>

    <div class="position-relative">
        <div class="multi-select-angular" style=" width: 150px; " *ngIf="isDetailedReport">
            <!-- <label name="label-imei" id="label-imei" class="m-0">IMEI Number 8</label> -->
            <angular2-multiselect name="multiselect-devices" id="multiselect-devices"
                class="hide_checkbox-select data_modelClas" [settings]="multipleSettings2" [lazyLoading]="true"
                [data]="maplist" [(ngModel)]="selectedMap" (ngModelChange)="changeMap($event)">
                <c-item>
                    <ng-template let-item="item">
                        <label>{{item.name}} <span *ngIf="item?.isWifi"  ><fa-icon [icon]="faWifi" ></fa-icon></span></label>
                    </ng-template>
                </c-item>
            </angular2-multiselect>
        </div>
        <div class="position-absolute translate-middle " style="right: 1%; top:40%" >
            <div *ngIf="fetchingMaps" class="loader"></div>
        </div>
     </div>


</div>

<app-modal [showPopup]="openBandlockInfo" name="create">

    <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabeldevice">Bandlock information</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="closeBandlockInfo()" >
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body">
        <div class="p-2">
            <table class="text-start ">
                <tbody>
                  <tr>
                    <td class="p-2 font-weight card-left-text">Device</td>
                    <td class="card-width pr-2">:</td>
                    <td>{{deviceDetails?.deviceid}} ({{deviceDetails?.name}})</td>
                  </tr>
                  <tr>
                    <td class="p-2 font-weight card-left-text">Device Status</td>
                    <td class="card-width pr-2">:</td>
                    <td>
                        <span id="param-value" name="param-value"
                        *ngIf="deviceStatusInfo === 'online';"
                        class="badge bg-success">Online</span>
                    <span id="param-value" name="param-value"
                        *ngIf="deviceStatusInfo === 'offline';"
                        class="badge bg-danger">Offline</span>
                    </td>
                  </tr>


            
                  </tbody>
                  </table>
        </div>
        <!-- (selectedTabChange)="onTabChange('html',$event)" [(selectedIndex)]="selectedTabIndex"  -->
        <mat-tab-group >
            <mat-tab *ngFor="let tab of sliceModems; let index = index;" [label]="tab.imei"
            [id]="tab.imei+index" [name]="tab.imei+index">
            <ng-template mat-tab-label>
                <div>{{tab.modem_name}}</div> 
                <div>{{tab.imei}}</div>
            </ng-template>
            <ng-template matTabContent>

         <div class="p-2">
            <p class="mt-1 mb-1">Applied MNO Map : <span *ngFor="let item of tab.template_names"> {{item}}</span></p>
            <p class="location-design fw-bold mt-2"> <span class="supported-dot"></span> SUPPORTED BANDS</p>

            <tabset>
                <!-- <tab [heading]="'3G'" [active]=true (selectTab)=false>
                    <div style="height: 100px;overflow-y: auto;">
                        <span *ngFor="let threeg of tab?.band_info?.SUPPORTED_BAND_3G">
                            <span class="badge rounded-pill bg-info  m-1 p-2">{{threeg}}</span>
                        </span>
                    </div>
                </tab> -->
                <tab [heading]="'4G'" [active]="selectedTab === '4G'" (selectTab)="selectedTab = '4G'">
                    <div style="height: 100px;overflow-y: auto;">
                        <!-- <span *ngFor="let fourg of tab?.band_info?.SUPPORTED_BAND_4G"> -->
                            <!-- <span class="badge rounded-pill bg-info  m-1 p-2">{{fourg}}</span>
                        </span> -->
                        <span *ngFor="let fourg of tab?.band_info?.SUPPORTED_BAND_4G">
                            <span 
                              class="badge rounded-pill m-1 p-2"
                              [ngClass]="{
                                'bg-success': tab?.band_info?.BAND_4G?.includes(fourg),
                                'bg-info': !tab?.band_info?.BAND_4G?.includes(fourg)
                              }">
                              {{fourg}}
                            </span>
                          </span>
                    </div>
                </tab>
                <tab [heading]="'5G'"  [active]="selectedTab === '5G'" (selectTab)="selectedTab = '5G'">
                    <div style="height: 100px;overflow-y: auto;">
                        <!-- <span *ngFor="let fiveg of tab?.band_info?.SUPPORTED_BAND_5G">
                            <span class="badge rounded-pill bg-info  m-1 p-2">{{fiveg}}</span>
                        </span> -->
                        <span *ngFor="let fiveg of tab?.band_info?.SUPPORTED_BAND_5G">
                            <span 
                              class="badge rounded-pill m-1 p-2"
                              [ngClass]="{
                                'bg-success': tab?.band_info?.BAND_5G?.includes(fiveg),
                                'bg-info': !tab?.band_info?.BAND_5G?.includes(fiveg)
                              }">
                              {{fiveg}}
                            </span>
                          </span>
                    </div>
                </tab>
                <tab [heading]="'NR5G'"  [active]="selectedTab === 'NR5G'" (selectTab)="selectedTab = 'NR5G'">
                    <div style="height: 100px;overflow-y: auto;">
                        <!-- <span *ngFor="let nsag of tab?.band_info?.SUPPORTED_BAND_NSA_5G">
                            <span class="badge rounded-pill bg-info  m-1 p-2">{{nsag}}</span>
                        </span> -->
                        <span *ngFor="let fiveg of tab?.band_info?.SUPPORTED_BAND_NSA_5G">
                            <span 
                              class="badge rounded-pill m-1 p-2"
                              [ngClass]="{
                                'bg-success': tab?.band_info?.BAND_NSA_5G?.includes(fiveg),
                                'bg-info': !tab?.band_info?.BAND_NSA_5G?.includes(fiveg)
                              }">
                              {{fiveg}}
                            </span>
                          </span>

                    </div>
                </tab>
            </tabset>
        </div>
        <hr style="border: 1px solid grey;">
        <div>
            <p class="location-design fw-bold"> <span class="green-dot"></span> LOCKED BANDS</p>
            <tabset>
                <!-- <tab [heading]="'3G'" [active]=true (selectTab)=false>
                    <div style="height: 100px;overflow-y: auto;">
                        <span *ngFor="let locthreeg of tab?.band_info?.BAND_3G">
                            <span class="badge rounded-pill bg-info  m-1 p-2">{{locthreeg}}</span>
                        </span>
                    </div>
                </tab> -->
                <tab [heading]="'4G'" [active]="selectedTab === '4G'" (selectTab)="selectedTab = '4G'">
                    <div style="height: 100px;overflow-y: auto;">
                        <span *ngFor="let locfourg of tab?.band_info?.BAND_4G">
                            <span class="badge rounded-pill bg-success  m-1 p-2">{{locfourg}}</span>
                        </span>
                    </div>
                </tab>
                <tab [heading]="'5G'"  [active]="selectedTab === '5G'" (selectTab)="selectedTab = '5G'">
                    <div style="height: 100px;overflow-y: auto;">
                        <span *ngFor="let locfiveg of tab?.band_info?.BAND_5G">
                            <span class="badge rounded-pill bg-success  m-1 p-2">{{locfiveg}}</span>
                        </span>
                    </div>
                </tab>
                <tab [heading]="'NR5G'"   [active]="selectedTab === 'NR5G'" (selectTab)="selectedTab = 'NR5G'">
                    <div style="height: 100px;overflow-y: auto;">
                        <span *ngFor="let locnsag of tab?.band_info?.BAND_NSA_5G">
                            <span class="badge rounded-pill bg-success  m-1 p-2">{{locnsag}}</span>
                        </span>
                    </div>
                </tab>
            </tabset>
        </div>
</ng-template>
        </mat-tab>
        </mat-tab-group>
    </div>
    <div class="modal-footer"> 
        <button type="button" class="btn btn-danger"    (click)="closeBandlockInfo()">Close</button>
        <!-- <button type="button" class="btn btn-primary" >Previous</button> -->
    </div>

</app-modal>